module.exports = __webpack_public_path__ + "static/img/ru.054d58b4.png";